var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Send(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.526 10.948c1.551-.916 1.54-3.165-.022-4.064L4.212.381C2.316-.712.086 1.15.822 3.21l2.029 5.68a.414.414 0 0 1 0 .279l-2.007 5.62c-.74 2.073 1.517 3.936 3.412 2.817l11.27-6.658Zm-.99-2.385a.415.415 0 0 1 .005.717L3.27 15.938a.415.415 0 0 1-.603-.497l1.944-5.442h4.16a.969.969 0 1 0 0-1.937h-4.16L2.647 2.559a.415.415 0 0 1 .598-.5l11.292 6.504Z" }) })));
}
export default Send;
